"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendingHints = void 0;
const UiKitLite_1 = require("../UiKitLite");
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
const ExtendingHints = () => {
    const [birthday, setBirthday] = (0, react_1.useState)(new Date());
    const cakeImage = 'https://images.unsplash.com/photo-1588195538326-c5b1e9f80a1b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80';
    const birthdayWidth = '300px';
    return (react_1.default.createElement(react_2.VStack, { spacing: 5, align: 'stretch' },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Success, { title: 'Title', textLines: ['Paris is the capital of France.'] },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Clickable, { text: 'Click me', onClick: () => {
                    alert('Clicked!');
                } })),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Info, { title: 'Key Concept', textLines: ['How to ride a bike.'], colored: true },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "You know, push the pedals and stuff")),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Warning, { title: 'Title', textLines: ['Paris is the capital of France.'] },
            react_1.default.createElement(react_2.HStack, { align: 'center', justify: 'flex-end', w: '100%' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Button.Primary, { text: 'Download Travel Guide', onClick: () => {
                        alert('Clicked!');
                    } }),
                react_1.default.createElement(UiKitLite_1.UiKitLite.Button.Secondary, { text: 'Cancel Reservation', onClick: () => {
                        alert('Clicked!');
                    } }))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Tip, { title: 'Title', textLines: [] },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null,
                "To learn more about the art in Paris, go to the",
                ' ',
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Clickable, { text: 'Louvre website', onClick: () => {
                        alert('Clicked!');
                    } }))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Tip, { title: 'Colored Tip Hint', textLines: [], colored: true },
            react_1.default.createElement(react_2.VStack, { align: 'stretch', spacing: UiKitLite_1.UiKitLite.consistency.buffer, w: birthdayWidth },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Let us know your birthday so we can send you cake!"),
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: birthday, onChange: setBirthday })),
            react_1.default.createElement(react_2.Image, { boxSize: birthdayWidth, objectFit: "cover", borderRadius: '20px', src: cakeImage, alt: 'Cake' })),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Warning, { title: 'Dataload not started', textLines: [], colored: true, removable: true },
            react_1.default.createElement(react_2.HStack, { flex: 1, align: 'center', spacing: UiKitLite_1.UiKitLite.consistency.halfBuffer },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Load your dataset at the SFTP location below."),
                react_1.default.createElement(react_2.HStack, { align: 'center', spacing: UiKitLite_1.UiKitLite.consistency.halfBuffer },
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Or"),
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Button.Secondary, { text: 'Upload your file', leftIcon: 'upload', onClick: () => {
                            alert('clicked');
                        }, isSmall: true })),
                "."))));
};
exports.ExtendingHints = ExtendingHints;
